import { render, staticRenderFns } from "./SpouseSurvey.vue?vue&type=template&id=0b8205e0"
import script from "./SpouseSurvey.vue?vue&type=script&lang=ts"
export * from "./SpouseSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports